import { Link } from "react-router-dom";

export const Logo = ({ className = "", imgClassName = "h-6", to = "/", clickable = true, testId = "brand-logo" }) => {
  const img = (
    <img src="/jobsmith-logo.png" alt="Jobsmith" className={`${imgClassName} w-auto`} draggable={false} />
  );
  if (!clickable) return <span className={`inline-flex items-center ${className}`}>{img}</span>;
  return (
    <Link to={to} aria-label="Jobsmith home" data-testid={testId} className={`inline-flex items-center ${className}`}>
      {img}
    </Link>
  );
};

export default Logo;
